module.exports = __webpack_public_path__ + "img/logo-new-cor.993b928f.png";